export default "__VITE_ASSET__BZBxxARw__"